import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

/**
 * UnsavedChangesModal - Confirmation dialog before leaving with unsaved changes
 * Now supports optional customization for overwrite confirmation use case
 */
export const UnsavedChangesModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Unsaved changes',
  message = 'You have unsaved changes. Are you sure you want to leave this page?',
  confirmLabel = 'Leave',
  cancelLabel = 'Stay',
}: UnsavedChangesModalProps) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onCancel} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-chariot-background-primary border-chariot-stroke mx-auto max-w-md rounded-lg border p-6">
          <DialogTitle className="text-chariot-text-primary text-lg font-semibold">
            {title}
          </DialogTitle>

          <div className="mt-4 space-y-2">
            <p className="text-chariot-text-secondary text-sm">{message}</p>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onCancel}
              className="bg-chariot-background-tertiary text-chariot-text-primary hover:bg-chariot-background-quaternary rounded-md px-4 py-2 text-sm font-medium transition-colors"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              className="rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-600"
            >
              {confirmLabel}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
